import { IUser, LOCAL_STORAGE_KEY } from '@/features/auth';

export const getLocalStorageUser = (): IUser => {
  const _user = window.localStorage.getItem(LOCAL_STORAGE_KEY);
  if (!_user) throw Error('User data has expired. Please login again.');
  return JSON.parse(_user);
};

export const getAccessToken = (user: IUser) => {
  const token = window.btoa(`Bearer:${user?.access_token}`);
  return `Basic ${token}`;
};

export const getRefreshToken = (user: IUser) => {
  return user?.refresh_token;
};

export const updateLocalStorageUser = (user: IUser) => {
  window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(user));
};

export const clearLocalStorageUser = () => {
  window.localStorage.removeItem(LOCAL_STORAGE_KEY);
};
